import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ChatbotSendActionType } from '../../bi';
import { loadChatbotStartChat } from '../thunks/chatbotStartChat.thunk';
import { chatActions } from './chat';
import { createState } from './fieldCreaters';
import { IFieldState } from './types';

const initialState: IFieldState = {
  maxLength: -1,
  disabled: false,
  hidden: true,
  placeholder: '',
  value: '',
  attachFile: false,
  multiline: false,
  nodeId: undefined,
  change: false,
  prevState: undefined,
};

export const fieldSlice = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    changeValue: (state, action: PayloadAction<string>) => {
      state.value = action.payload;
    },
    updateChatbot: (state, action: PayloadAction<Partial<IFieldState>>) => {
      return createState(action.payload);
    },
    updateLiveChatbot: (state, action: PayloadAction<Partial<IFieldState>>) => {
      state.nodeId = action.payload.nodeId;
      state.placeholder = action.payload.placeholder;
    },
    sendMessage: (
      state,
      _action: PayloadAction<{ bi: { sendActionType: ChatbotSendActionType } }>, // used in middleware
    ) => {
      state.prevState = {
        value: state.value,
        attachFile: state.attachFile,
        multiline: state.multiline,
        change: state.change,
        disabled: state.disabled,
      };

      state.disabled = true;
      state.value = '';
      state.attachFile = false;
      state.multiline = false;
      state.change = false;
    },
    setDisabled: (state, action: PayloadAction<boolean>) => {
      state.disabled = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(chatActions.reset, () => {
      return initialState;
    });
    builder.addCase(loadChatbotStartChat.fulfilled, (state, action) => {
      return createState(action.payload.ui ?? {});
    });
    builder.addCase(chatActions.addUndelivered, (state) => {
      return {
        ...state,
        ...state.prevState,
      };
    });
  },
});

export const fieldActions = fieldSlice.actions;
